import React from 'react';
import { func } from 'prop-types';
import { userType } from 'types';

import FormWrapper from 'components/FormWrapper';
import { CSS_OVERFLOW } from 'utils/constants';
import InnerForm from './innerForm';

const UserForm = ({ hideModal, onSubmit, user }) => (
  <FormWrapper
    overflowBehaviour={CSS_OVERFLOW.VISIBLE}
    formName="Add new user"
    handleSubmit={onSubmit}
    initialValues={{
      email: '',
      firstName: '',
      lastName: '',
      role: user ? user.role : undefined
    }}
    validationSchema={InnerForm.validationSchema}
  >
    <InnerForm hideModal={hideModal} />
  </FormWrapper>
);

UserForm.propTypes = {
  hideModal: func.isRequired,
  onSubmit: func.isRequired,
  user: userType
};

export default UserForm;
